const toRadians = (degrees: number): number => (degrees * Math.PI) / 180;

export const getDistanceKm = (firstLat: number, firstLng: number, secondLat: number, secondLng: number): number => {
  const earthRadiusKm = 6371;
  const deltaLat = toRadians(secondLat - firstLat);
  const deltaLng = toRadians(secondLng - firstLng);

  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(toRadians(firstLat)) * Math.cos(toRadians(secondLat)) *
    Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return earthRadiusKm * c;
};
